import React, {
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Modal,
  Row,
  Col,
  Button,
  Form,
  Input,
  Typography,
  Divider,
  Select,
  DatePicker,
  TimePicker,
} from "antd";
import "./TreatmentSheet.scss";
import Icons from "assets/icons";
import TextArea from "antd/es/input/TextArea";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import { dieuTriKhac, dieuTriMongOptions, dieuTriTTTOptions } from "./config";
import ServiceTable from "./Services/Services";
import { ModalCustom, Notification } from "components/common";
import PrescriptionTable from "./PrescriptionTable/PrescriptionTable";
import { inpatientService, storeService } from "api";
import PrintContent from "./PrintContent";
import ReactToPrint from "react-to-print";
import { birthday2Age, formatDateToString } from "helper/common";
import { useAppSelector } from "redux/hooks";
import residentialNurseService from "api/residentialNurse";
// import listAssign from "redux/reducer/listAssign";
import ListAssignModal from "./ListAssignModal/ListAssignModal";
import dayjs from "dayjs";

const TreatmentSheet = React.forwardRef((props: any, ref) => {
  let residentialNurse = useAppSelector((state) => state.residentialNurse);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();
  const [isView, setIsView] = useState<boolean>(false);
  const [isViewDichVu, setIsViewDichVu] = useState<boolean>(false);
  const [rows, setRows] = useState<any>([]);
  const [type, setType] = useState<number>(0);
  const [kind, setKind] = useState<number>(null);
  const printRef = useRef<any>();
  const listAssignRef = useRef<any>();
  const [savedServices, setSavedServices] = useState<any>(null);
  const [savedMedicals, setSavedMedicals] = useState<any>(null);
  const [listAssign, setListAssign] = useState<any>();
  const [by, setBy] = useState<any>("");
  const [listTDT, setListTDT] = useState([]);

  // const colums = [
  //   {
  //     title: <Typography.Text strong>Nội dung</Typography.Text>,
  //     dataIndex: "noiDung",
  //     key: "noiDung",
  //   },
  //   {
  //     title: <Typography.Text strong>Cách tính điểm</Typography.Text>,
  //     dataIndex: "noiDung",
  //     key: "noiDung",
  //   },
  //   {
  //     title: <Typography.Text strong>Cách tính điểm</Typography.Text>,
  //     dataIndex: "noiDung",
  //     key: "noiDung",
  //   },
  // ];
  const [dataThuocs, setDataThuocs] = useState<any>([]);
  const fetchListThuocByParam = async (params) => {
    try {
      let response = await storeService.getListMedicineByParams(params);
      // console.log("🚀 ~ fetchListThuocByParam ~ response:", response)
      setDataThuocs(response);
    } catch (err) {
      // notification.error({message: "Lỗi khi lấy danh sách thuốc!"});
    }
  };
  useEffect(() => {
    fetchListThuocByParam({
      page: 1,
      limit: 9999,
    });
  }, []);
  const sRef = useRef<any>();
  const pRef = useRef<any>();
  const [options, setOptions] = useState<any>([]);
  const [data, setData] = useState<any>(null);
  const resetFields = () => {
    form.resetFields();
    setRows([]);
  };
  const getListAssign = async () => {
    try {
      // let _listAssign = [];

      const toDieuTri = await inpatientService.getToDieuTri(data?.id);
      // toDieuTri?.phieuChiDinhDtos?.forEach((phieu) => {
      //   phieu?.nhomChiDinhDtos?.forEach((nhom) => {
      //     _listAssign = [..._listAssign, ...nhom?.chiDinhDtos];
      //   });
      // });
      setListAssign(toDieuTri?.phieuChiDinhDtos ?? []);
    } catch (error) {
      setListAssign([]);
    }
  };
  useEffect(() => {
    getListAssign();
  }, [data]);
  const mapTableToString = (data) => {
    let tmp = {};
    Object.entries(data).forEach(([key, value]: any) => {
      tmp[key] = {
        ngay: value.ngay ? value.ngay.format("DD/MM/YYYY") : null,
        gio: value.gio ? value.gio.format("HH:mm") : null,
        dienBienBenh: value.dienBienBenh,
        yLenh: value.yLenh,
        thuocVaDichVu: value.thuocVaDichVu,
      };
    });
    return tmp;
  };
  const parseTable = (data) => {
    let tmp = {};
    Object.entries(data).forEach(([key, value]: any) => {
      tmp[key] = {
        ngay: value.ngay ? dayjs(value.ngay, "DD/MM/YYYY") : null,
        gio: value.gio ? dayjs(value.gio, "HH:mm") : null,
        dienBienBenh: value.dienBienBenh,
        yLenh: value.yLenh,
        thuocVaDichVu: value.thuocVaDichVu,
      };
    });
    return tmp;
  };
  // const getData = () => {
  //   let tmp = form.getFieldsValue();
  //   return {
  //     ...tmp,
  //     table: tmp.table ? mapTableToString(tmp.table) : null,
  //   };
  // };
  const [listTTNhanTao, setListTTNhanTao] = useState([]);
  const getListLoaiTTT = async () => {
    try {
      const res = await residentialNurseService.getListLoaiTTT();

      setListTTNhanTao(res.data);
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách loại thủy tinh thể nhân tạo"
      );
    }
  };
  const [print, setPrint] = useState<boolean>(false);
  useImperativeHandle(ref, () => ({
    setPrint: setPrint,
    openModal: (isView, isViewDichVu) => {
      setOptions([]);
      if (isView === true) {
        setType(2);
        setIsView(true);
      } else if (isView === false) {
        setIsView(false);

        setType(1);
      } else {
        setType(0);
        setIsView(false);
      }
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setRows: setRows,
    getValue: form.getFieldValue,
    getValues: form.getFieldsValue,
    setValue: form.setFieldValue,
    setValues: form.setFieldsValue,
    resetFields: resetFields,
    setIsViewDichVu: setIsViewDichVu,

    setData: setData,
    setListTDT: (data) => setListTDT(data),
    getData: () => {
      const valueThuocvaDichVus = form.getFieldValue([
        "table",
        "row0",
        "thuocVaDichVu",
      ]);

      let donThuocDtos = [];
      valueThuocvaDichVus.map((item) => {
        dataThuocs.find((e) => (e.name === item ? donThuocDtos.push(e) : null));
        // donThuocDtos.push(result);
      });
      return {
        id: data?.id ?? null,
        donThuocDtos: donThuocDtos ?? [],

        phieuChiDinhDtoList: data?.phieuChiDinhDtoList ?? [],
        toDieuTri: JSON.stringify({
          ...form.getFieldsValue(),
          table: mapTableToString(form.getFieldValue("table")),
          by: by,
          lanSuaCuoi:
            (form.getFieldValue(["table", "row0", "gio"])?.format("HH:mm ") ??
              "") +
            (form
              .getFieldValue(["table", "row0", "ngay"])
              ?.format("DD/MM/YYYY") ?? ""),
          kind: kind,
        }),
        ngay: form.getFieldValue(["table", "row0", "ngay"]),
        gio: form.getFieldValue(["table", "row0", "gio"]),
      };
    },
    setKind: setKind,
    getSavedServices: () => {
      return savedServices;
    },
    getSavedMedicals: () => {
      return savedMedicals;
    },
    serviceSave: serviceSave,
    medicineSave: medicineSave,
  }));

  // const selectOptions = useMemo(() => {
  //   return listTDT
  //     .filter((el) => el.loaiToDieuTri === kind)
  //     .map((el) => ({
  //       value: el.id,
  //       label: el.toDieuTri,
  //       dienBienBenh: el.moTa,
  //       yLenh: el.yLenh,
  //     }));
  // }, [kind, listTDT]);
  const selectOptions = useMemo(() => {
    switch (kind) {
      case 0:
        return dieuTriMongOptions;
      case 1:
        return dieuTriTTTOptions;
      case 2:
        return dieuTriKhac;

      default:
        break;
    }
  }, [kind]);
  // const onFinish = async (values) => {};
  const toDT = Form.useWatch("to", form);
  const handleOnClick = async () => {
    if (toDT == null || toDT === undefined) {
      Notification("warning", "Chưa chọn phiếu điều trị!");
      return;
    }
    await props.onSave(type, kind);

    closeModal();
  };
  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getTTNhanTaoYLenh = (ttNhanTao, toSo) => {
    if (toSo != 2 || ttNhanTao == null || ttNhanTao == undefined) return "";
    let tmp = listTTNhanTao.find((it) => it.id == ttNhanTao);
    return `${tmp?.tenTheoThuongMai} (1 lần)`;
  };
  const onAddRow = async () => {
    if (
      rows.length === 0 &&
      form.getFieldValue("to") != null &&
      form.getFieldValue("to") != undefined
    ) {
      form.setFieldValue(["table", `row${rows.length}`], {
        ...selectOptions[Number(form.getFieldValue("to"))],
        yLenh:
          selectOptions[Number(form.getFieldValue("to"))]?.yLenh +
          getTTNhanTaoYLenh(props.ttNhanTao, Number(form.getFieldValue("to"))),
      });
      setRows([
        ...rows,
        {
          ...selectOptions[Number(form.getFieldValue("to"))],
        },
      ]);
      sRef.current?.setData([]);
      pRef.current?.setData([]);
    }
  };
  const onAddService = async () => {
    const day = form.getFieldValue(["table", "row0", "ngay"]);

    if (
      form.getFieldValue(["table", "row0", "ngay"]) &&
      form.getFieldValue(["table", "row0", "gio"])
    ) {
      sRef.current?.setSelectedServices([]);
      sRef.current?.openModal();
    } else {
      Notification("warning", "Hãy thêm ngày giờ!");
      return;
    }
  };
  const onAddMedical = async () => {
    pRef.current?.setData([]);
    pRef.current?.openModal();
  };

  const handleServiceSave = async () => {
    let dvs = sRef.current?.getData();
    if (data.id !== null) {
      setSavedServices(dvs);
      try {
        if (!dvs || dvs.length === 0) {
          Notification("warning", "Chưa có dịch vụ được thêm!");
          return;
        }
        let ngay = form.getFieldValue(["table", "row0", "ngay"]);
        let dt = {
          idToDieuTri: data.id,
          ngayTaoPhieu:
            (ngay ? ngay.format("YYYY-MM-DDT") : "0000-00-00T") +
            (form
              .getFieldValue(["table", "row0", "gio"])
              ?.format("HH:mm:ss.sssZ") || "00:00:00.000-00:00"),
          bacSyChiDinh: localStorage.getItem("fullName"),
          chiDinhDtos: dvs.map((it) => ({
            id: 0,
            bhNgoaiTru: it.bhNgoaiTru,
            bhNoiTru: it.bhNoiTru,
            hienThiBangKe: it.hienThiBangKe,
            idPhieuchiDinh: 0,
            tenChiDinh: it.tenDichVu,
            baoHiemTra: it.bhChiTra,
            maDichVu: it.id,
            thoiGian:
              (ngay ? ngay.format("YYYY-MM-DDT") : "0000-00-00T") +
              (form
                .getFieldValue(["table", "row0", "gio"])
                ?.format("HH:mm:ss.sssZ") || "00:00:00.000-00:00"),
            donGia: it.donGia,
            soLuong: it.soLuong,
            thanhTien: it.soLuong * it.donGia,
            coBaoHiem: it.coBaoHiem,
            canTuVan: it.canTuVan,
            ghiChu: it.ghiChu,
            trangThai: 0,
            trangThaiThanhToan: 0,
          })),
        };
        let response = await inpatientService.postPhieuChiDinh(dt);
        setData({
          ...data,
          phieuChiDinhDtos: [
            ...data.phieuChiDinhDtos,
            {
              ...response,
              idToDieuTri: data.id,
            },
          ],
        });
        Notification("success", "Lưu thành công!");
      } catch (err) {
        Notification("error", "Thêm dịch vụ không thành công");
      }
    } else {
      setSavedServices(dvs);
      let oldDt = form.getFieldValue(["table", `row0`, "thuocVaDichVu"]);
      oldDt ? (oldDt = oldDt) : (oldDt = []);
      setOptions([
        ...options,
        ...dvs.map((it) => ({ value: it.tenDichVu, label: it.tenDichVu })),
      ]);
      form.setFieldValue(
        ["table", `row0`, "thuocVaDichVu"],
        [...oldDt, ...dvs.map((it) => it.tenDichVu)]
      );
    }
  };
  const onPrintSheet = () => {
    window.print();
  };
  const serviceSave = async (idToDieuTri) => {
    try {
      let ngay = form.getFieldValue(["table", "row0", "ngay"]);
      let dt = {
        idToDieuTri: idToDieuTri,
        ngayTaoPhieu:
          (ngay ? ngay.format("YYYY-MM-DDT") : "0000-00-00T") +
          (form
            .getFieldValue(["table", "row0", "gio"])
            ?.format("HH:mm:ss.sssZ") || "00:00:00.000-00:00"),
        bacSyChiDinh: localStorage.getItem("fullName"),
        chiDinhDtos: savedServices.map((it) => ({
          id: 0,
          idPhieuchiDinh: 0,
          tenChiDinh: it.tenDichVu,
          baoHiemTra: it.bhChiTra,
          maDichVu: it.id,
          thoiGian:
            (ngay ? ngay.format("YYYY-MM-DDT") : "0000-00-00T") +
            (form
              .getFieldValue(["table", "row0", "gio"])
              ?.format("HH:mm:ss.sssZ") || "00:00:00.000-00:00"),
          donGia: it.donGia,
          soLuong: it.soLuong,
          thanhTien: it.soLuong * it.donGia,
          coBaoHiem: it.coBaoHiem,
          canTuVan: it.canTuVan,
          ghiChu: it.ghiChu,
          trangThai: 0,
          trangThaiThanhToan: 0,
          bhNgoaiTru: it.bhNgoaiTru,
          bhNoiTru: it.bhNoiTru,
          hienThiBangKe: it.hienThiBangKe,
        })),
      };
      let response = await inpatientService.postPhieuChiDinh(dt);
      setData({
        ...data,
        phieuChiDinhDtos: [
          ...(data?.phieuChiDinhDtos ?? []),
          {
            ...response,
            idToDieuTri: idToDieuTri,
          },
        ],
      });
      setSavedServices(null);
    } catch (err) {}
  };
  // thêm thuốc
  const handleMedicineSave = async () => {
    let ps = pRef.current?.getData();
    //trường họp đã có phiếu
    if (data.id !== null) {
      try {
        let dt = {
          thuocs: ps,
          idToDieuTri: data.id,
        };
        let response = await inpatientService.postDonThuoc(
          dt,
          residentialNurse?.idPhieuKham ?? null
        );
        setOptions([
          ...options,
          ...ps
            .filter((et) => !thuocs.find((dt) => dt.tenChiDinh == et.tenThuoc))
            .map((it) => ({ value: it.tenThuoc, label: it.tenThuoc })),
        ]);
        let oldDt = form.getFieldValue(["table", `row0`, "thuocVaDichVu"]);
        form.setFieldValue(
          ["table", `row0`, "thuocVaDichVu"],
          [
            ...oldDt,
            ...ps
              .filter(
                (et) => !thuocs.find((dt) => dt.tenChiDinh == et.tenThuoc)
              )
              .map((it) => it.tenThuoc),
          ]
        );

        Notification("success", "Lưu thành công!");
      } catch (err) {}
    }
    // trường họp chưa có phiêu
    else {
      setSavedMedicals(ps);
      let oldDt = form.getFieldValue(["table", `row0`, "thuocVaDichVu"]);
      // oldDt ? (oldDt = oldDt) : (oldDt = []);
      setOptions([
        ...options,
        ...ps.map((it) => ({ value: it.tenThuoc, label: it.tenThuoc })),
      ]);

      form.setFieldValue(
        ["table", `row0`, "thuocVaDichVu"],
        [...oldDt, ...ps.map((it) => it.tenThuoc)]
      );

      // const dataTable = ps?.map((item, index) => {
      //   return {
      //     key: item?.id,
      //     tenChiDinh: "",
      //     maDichVu: "",
      //     stt: index + 1,
      //     thoiGian: formatDateToString(dayjs()),
      //     children: {
      //       key: `${item?.id}${index}`,
      //       tenChiDinh: "",
      //       thoiGian: "",
      //       children: {
      //         ...item,
      //         key: item.id,
      //       },
      //     },
      //   };
      // });
      // console.log("🚀 ~ dataTable ~ dataTable:", dataTable)
      // setListAssign([...listAssign, ...dataTable]);
    }
  };

  // thêm đơn thuốc vào tờ điều trị
  const medicineSave = async (idToDieuTri) => {
    try {
      let dt = {
        thuocs: savedMedicals,
        idToDieuTri: idToDieuTri,
      };
      let response = await inpatientService.postDonThuoc(
        dt,
        residentialNurse?.idPhieuKham ?? null
      );
      setData({
        ...data,
        donThuocDtos: [...(data?.donThuocDtos ?? []), response],
      });
      setSavedMedicals(null);
    } catch (err) {}
  };
  const handleOnChange = async () => {
    setRows([]);
  };
  // const onChangeType = async () => {
  //   setRows([]);
  // };
  // const handleOnTagDeselect = async (value, opts) => {
  //   if (opts.type === 0) {
  //     sRef.current.clearItem(opts.value);
  //     // setOptions([...options.filter(it => it.value !== opts.value)])
  //   } else if (opts.type === 1) {
  //     pRef.current.clearItem(opts.value);
  //     // setOptions([...options.filter(it => it.value !== opts.value)])
  //   }
  // };
  // const handleValueChange = async (changedValue, allValues) => {};

  const [dmBuong, setDmBuong] = useState<any>([]);
  const [dmGiuong, setDmGiuong] = useState<any>([]);
  const fetchDanhMucGiuongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucGiuongBenh(params);
      setDmGiuong(response.data);
    } catch (err) {}
  };
  const fetchDanhMucPhongBenh = async (params) => {
    try {
      let response = await inpatientService.getListDanhMucPhongBenh(params);
      setDmBuong(response.data);
    } catch (err) {}
  };

  useEffect(() => {
    fetchDanhMucGiuongBenh({ page: 1, limit: 100 });
    fetchDanhMucPhongBenh({ page: 1, limit: 100 });
    getListLoaiTTT();
  }, []);
  // useEffect(() => {}, [isView]);
  const [dichVus, setDichVus] = useState<any>([]);
  const [thuocs, setThuocs] = useState<any>([]);
  // console.log("🚀 ~ TreatmentSheet ~ thuocs:", thuocs);
  const getThuocs = (dts) => {
    let res = [];
    dts.map((it) => {
      it.nhomChiDinhDtos.map((et) => {
        if (et.tenNhomChiDinh == "Thuốc") {
          res = [...res, ...et.chiDinhDtos];
        }
      });
    });

    return res;
  };
  const getDichVus = (dvs) => {
    let res = [];
    dvs.map((it) => {
      it.nhomChiDinhDtos.map((et) => {
        res = [...res, ...et.chiDinhDtos];
      });
    });
    return res;
  };
  useEffect(() => {
    if (data) {
      printRef?.current.setData({ ...data });
      let formData = JSON.parse(data?.toDieuTri ?? "{}");
      let rs = [];
      formData?.table
        ? Object.entries(formData.table).forEach(([key, value]: any) => {
            rs = [
              ...rs,
              {
                dienBienBenh: value.dienBienBenh,
                yLenh: value.yLenh,
                thuocVaDichVu: value.thuocVaDichVu,
              },
            ];
          })
        : null;
      setRows(rs);
      if (formData?.by) {
        setBy(formData.by);
      } else setBy(localStorage.getItem("fullName"));
      form.setFieldsValue({
        ...data,
        tuoi: data.ngaySinh ? birthday2Age(data.ngaySinh) : null,
        ...formData,
        table: formData.table ? parseTable(formData.table) : null,
        buong: data?.idBuongSo,
        giuong: data?.idGiuongSo,
      });
      setThuocs(getThuocs(data?.phieuChiDinhDtos ?? []));
      setDichVus(getDichVus(data?.phieuChiDinhDtos ?? []));
    } else {
      setRows([]);
      form.setFieldsValue({
        table: null,
      });
      sRef.current?.setData([]);
      pRef.current?.setData([]);
    }
  }, [data]);

  useEffect(() => {
    setOptions([
      // ...thuocs.map((it) => ({ value: it.tenChiDinh, label: it.tenChiDinh })),
      ...dichVus.map((it) => ({ value: it.tenChiDinh, label: it.tenChiDinh })),
    ]);
    form.setFieldValue(
      ["table", "row0", "thuocVaDichVu"],
      [
        // ...thuocs.map((it) => it.tenChiDinh),
        ...dichVus.map((it) => it.tenChiDinh),
      ]
    );
  }, [dichVus, thuocs]);
  return (
    <div className="modal">
      <Modal
        wrapClassName="modal-custom"
        centered
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        title={"Tờ điều trị"}
        destroyOnClose={true}
        width={1080}
        forceRender={true}
        maskClosable={false}
        closeIcon={false}
      >
        <Row>
          <Row>
            <Form
              form={form}
              // onFinish={onFinish}
              // onValuesChange={handleValueChange}
            >
              <Row gutter={[4, 8]}>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Họ tên BN</Typography.Text>
                    }
                    name="hoTen"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input
                      className="data-input-field"
                      placeholder="Nhập"
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Tuổi</Typography.Text>}
                    name="tuoi"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input
                      className="data-input-field"
                      placeholder="Nhập"
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Giới tính</Typography.Text>
                    }
                    name="gioiTinh"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select
                      disabled={true}
                      className="data-select-field"
                      options={gioiTinhOptions.filter(
                        (it) => it.value !== null
                      )}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Địa chỉ</Typography.Text>}
                    name="diaChi"
                    labelAlign="left"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    <Input
                      className="data-input-field"
                      placeholder="Nhập"
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Khoa mắt TH</Typography.Text>
                    }
                    name="khoaDieuTri"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Input
                      className="data-input-field"
                      placeholder="--"
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Buồng</Typography.Text>}
                    name="buong"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select
                      className="data-input-field"
                      // disabled={true}
                      options={dmBuong.map((it) => ({
                        value: it.id,
                        label: it.tenPhong,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                  <Form.Item
                    label={<Typography.Text ellipsis>Giường</Typography.Text>}
                    name="giuong"
                    labelAlign="left"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                  >
                    <Select
                      className="data-input-field"
                      placeholder="Nhập"
                      disabled={true}
                      options={dmGiuong.map((it) => ({
                        value: it.id,
                        label: it.soGiuong,
                      }))}
                    />
                  </Form.Item>
                </Col>
                <Col xs={20} sm={20} md={22} lg={23} xl={23}>
                  <Form.Item
                    label={
                      <Typography.Text ellipsis>Chọn phiếu</Typography.Text>
                    }
                    name="to"
                    labelAlign="left"
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 22 }}
                  >
                    <Select
                      className="data-input-field"
                      placeholder="Chọn"
                      options={selectOptions}
                      disabled={isView}
                      onChange={handleOnChange}
                    />
                  </Form.Item>
                </Col>
                <Col xs={4} sm={4} md={2} lg={1} xl={1}>
                  <Button
                    type="primary"
                    icon={<Icons.add />}
                    onClick={onAddRow}
                    disabled={isView}
                  ></Button>
                </Col>
              </Row>

              <Divider type="horizontal" />
              <Row justify="end" style={{ gap: "4px", marginBottom: "4px" }}>
                {/* thêm dịch vụ */}
                <ServiceTable
                  ref={sRef}
                  onSave={handleServiceSave}
                  setListAssign={setListAssign}
                />
                {/* Thêm thuốc */}
                <PrescriptionTable
                  ref={pRef}
                  onSave={handleMedicineSave}
                  setOptions={setOptions}
                  options={options}
                  thuocs={dataThuocs}
                  // setListAssign={setListAssign}
                />
                <Button
                  className="btn-sub"
                  disabled={isView}
                  type="primary"
                  onClick={() => {
                    listAssignRef?.current?.openModal();
                  }}
                >
                  Danh sách chỉ định
                </Button>
                <ModalCustom
                  title="Danh sách chỉ định"
                  ref={listAssignRef}
                  centered
                  width={1400}
                >
                  <ListAssignModal
                    // dataThuocs = {dataS}
                    listAssign={listAssign}
                    setListAssign={setListAssign}
                    setDichVus={setDichVus}
                    idToDieuTri={data?.id}
                  ></ListAssignModal>
                </ModalCustom>
                <Button
                  className="btn-sub"
                  type="primary"
                  onClick={onAddService}
                  disabled={isView}
                >
                  Bổ sung dịch vụ
                </Button>
                <Button
                  className="btn-sub"
                  type="primary"
                  onClick={onAddMedical}
                  disabled={isView}
                >
                  Bổ sung thuốc điều trị
                </Button>
              </Row>
              <div className="my-table-custom">
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Ngày</Typography.Text>
                      </th>
                      <th style={{ width: "8%" }}>
                        <Typography.Text strong>Giờ</Typography.Text>
                      </th>
                      <th style={{ width: "48%" }}>
                        <Typography.Text strong>Diễn biến bệnh</Typography.Text>
                      </th>
                      <th style={{ width: "16%" }}>
                        <Typography.Text strong>Y lệnh</Typography.Text>
                      </th>
                      <th style={{ width: "16%" }}>
                        <Typography.Text strong>
                          Thuốc và dịch vụ
                        </Typography.Text>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((it, index) => {
                      return (
                        <tr>
                          <td>
                            <Form.Item
                              name={["table", `row${index}`, "ngay"]}
                              initialValue={dayjs()}
                            >
                              <DatePicker
                                className="input-noborder"
                                bordered={false}
                                placeholder="DD/MM/YYYY"
                                disabled={isView}
                                format={"DD/MM/YYYY"}
                                changeOnBlur={true}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item name={["table", `row${index}`, "gio"]}>
                              <TimePicker
                                className="input-noborder"
                                bordered={false}
                                placeholder="HH:mm"
                                disabled={isView}
                                format={"HH:mm"}
                                changeOnBlur={true}
                                needConfirm={false}
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={["table", `row${index}`, "dienBienBenh"]}
                            >
                              <TextArea
                                className="input-noborder"
                                bordered={false}
                                disabled={isView}
                                autoSize
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item name={["table", `row${index}`, "yLenh"]}>
                              <TextArea
                                className="input-noborder"
                                bordered={false}
                                disabled={isView}
                                autoSize
                              />
                            </Form.Item>
                          </td>
                          <td>
                            <Form.Item
                              name={["table", `row${index}`, "thuocVaDichVu"]}
                            >
                              <Select
                                className="input-noborder"
                                // tagRender={tagRender}
                                mode="multiple"
                                bordered={false}
                                disabled={false}
                                options={options}
                                // onDeselect={handleOnTagDeselect}
                                removeIcon={false}
                              />
                            </Form.Item>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </Form>
            <Row>
              <PrintContent ref={printRef} />
            </Row>
          </Row>
          <Row justify={"end"} style={{ gap: "4px", marginTop: "4px" }}>
            <Button
              type="primary"
              icon={<Icons.close />}
              danger
              onClick={closeModal}
            >
              Hủy
            </Button>
            {print ? (
              <ReactToPrint
                trigger={() => {
                  return (
                    <Button
                      type="primary"
                      icon={<Icons.printer />}
                      onClick={onPrintSheet}
                    >
                      In phiếu
                    </Button>
                  );
                }}
                content={() => {
                  return printRef.current?.getContentPrint();
                }}
                onAfterPrint={closeModal}
              />
            ) : (
              <Button
                type="primary"
                icon={<Icons.save />}
                onClick={handleOnClick}
                disabled={isView}
              >
                Lưu
              </Button>
            )}
          </Row>
        </Row>
      </Modal>
    </div>
  );
});

export default TreatmentSheet;
